import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/upgrade.css";
import "../components/Plan/plan.css";

import HeroSection from "../components/Plan/HeroSection";
import PricingSection from "../components/Plan/PricingSection";
import PaymentLogosSection from "../components/Plan/PaymentLogosSection";
import WhyListSection from "../components/Plan/WhyListSection";
import FaqComponent from "../components/Plan/FaqSection";

import End_icon from "../assets/images/plan/end-icon.png";

const Upgrade = () => {

  const navigate = useNavigate();

  const faqList = [
    {
      faq_que: "What is a dedicated vendor webpage and how does it help my business??",
      faq_ans: "Simply choose your preferred plan, complete the registration process, and start adding your Umrah and Hajj packages. Our team will verify your details and activate your listings within 24-48 hours.",
    },
    {
      faq_que: "How will pilgrims discover my packages and contact me through my vendor webpage?",
      faq_ans: "",
    },
    {
      faq_que: "Can I upgrade my vendor plan at any time as my business grows?",
      faq_ans: "",
    },
    {
      faq_que: "How does Recommended Packages placement work and improve my package visibility?",
      faq_ans: "",
    },
        {
      faq_que: "What is the Verified Vendor badge, and how can I become verified on Bashaarat?",
      faq_ans: "",
    },
  ];

  return (
    <section className="upgrade">

      {/* Close Button */}
      <button
        className="upgrade-close"
        onClick={() => navigate("/")}
      >
        ✕
      </button>

      <HeroSection />
      <PricingSection />

      <div style={{ textAlign: "center", paddingBottom: "40px",paddingTop: "40px" }}>
        <img src={End_icon} alt="icon" />
      </div>

      <PaymentLogosSection />

      <div style={{ textAlign: "center", paddingBottom: "40px",paddingTop:"20px" }}>
        <img src={End_icon} alt="icon" />
      </div>

      <WhyListSection />

  
      <div style={{ textAlign: "center", paddingBottom: "40px"}}>
        <img src={End_icon} alt="icon" />
      </div>

      <FaqComponent faqList={faqList} />

    </section>
  );
};

export default Upgrade;